import { type FC, memo, useCallback } from 'react';
import { isNil } from 'lodash';
import moment, { type Moment } from 'moment';
// Import UI components
import { DatePickerInput, ExtendedInput } from '@geneui/components';

type ValidatableDatePickerInputProps = React.ComponentProps<typeof DatePickerInput> &
    React.ComponentProps<typeof ExtendedInput>;

type DateType = Nullable<string | Date | Moment>;

interface Props extends ValidatableDatePickerInputProps {
    errorText?: string;
    isTouched?: boolean;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (date: DateType) => void;
    value?: DateType;
    withTime?: boolean;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

const ValidatableDatePickerInput: FC<Props> = ({ errorText, isTouched, onBlur, onChange, value, ...rest }) => {
    const changeHandler = useCallback(
        (newDate: DateType) => {
            if (!moment(newDate).isSame(moment(value)) || isNil(value)) {
                onChange?.(newDate);
            }
        },
        [value, onChange],
    );

    return (
        <div className="c-date-picker">
            <DatePickerInput
                autocomplete="off"
                isValid={!(isTouched && errorText)}
                onBlur={onBlur}
                value={value}
                onChange={changeHandler}
                {...rest}
            />
            <p className="information-message color-danger">{isTouched && errorText}</p>
        </div>
    );
};

export default memo(ValidatableDatePickerInput);
